'use strict';

(function ($, FUNCTIONS) {
	var a = 'is-active';
	var v = 'is-visible';
	var slideSpeed = '400';

	// ＜ルート設定対応＞要素が空だったら削除
	var removeElmIfEmpty = function removeElmIfEmpty() {
		$('.js-checkEmptyElm').each(function (idx, val) {
			if (!$(val).text().length) {
				$(val).remove();
			}
		});
	};
	// ＜ルート設定対応＞該当のリストにルート設定出力が0件の場合、指定する親ブロックごと削除する
	var removeBlockIfListEmpty = function removeBlockIfListEmpty() {
		if ($('.js-checkEmptyList').length) {
			$('.js-checkEmptyList').each(function (idx, val) {
				if (!$(val).find('li').length) {
					$(val).parents('.js-checkEmptyList-wrap').remove();
				}
			});
		}
	};

	// モーダル Youtube再生
	var playYoutube = function playYoutube() {
		$('.js-modalYoutube').magnificPopup({
			disableOn: false,
			type: 'iframe',
			mainClass: 'mfp-fade',
			removalDelay: 160,
			preloader: false,
			fixedContentPos: false
		});
	};
	//
	var playRadio = function playRadio() {
		$('.js-modalAudio').magnificPopup({
			type: 'inline'
		});
	};
	var modalImg = function modalImg() {
		$('.mod-modal').on('click', function (e) {
			var HTML = '<div class="mod-modal-overlay">';
			HTML += '<div class="mod-modal-closeArea"></div>' + '<span class="mod-modal-closeBtn"><svg class="icon"><use xlink:href="/common/svg/sprite.svg#close" /></svg></span>' + ($(e.currentTarget).find('img').prop('outerHTML') + '</div>');
			$('body').append(HTML);

			var $overlay = $('.mod-modal-overlay');
			$overlay.addClass('is-active');
			setTimeout(function () {
				$overlay.addClass('is-visible');

				$('.mod-modal-closeArea, .mod-modal-closeBtn').on('click', function () {
					$overlay.removeClass('is-visible');
					setTimeout(function () {
						$overlay.removeClass('is-active');
						$overlay.remove();
					}, 400);
				});
			});
		});
	};

	// removeElmIfEmpty();
	// removeBlockIfListEmpty();
	playYoutube();
	playRadio();
	modalImg();
})(window.jQuery, window.FUNCTIONS);